import { pluralize } from "utils/pluralize";
import { DeadlineActionItem } from "store/apis/actionItems";

type Noun = { singular: string; plural: string };

// Keyed by the exact custom_type strings the by_deadline endpoint emits.
const CUSTOM_TYPE_NOUN: Record<string, Noun> = {
  document_request: {
    singular: "document requested",
    plural: "documents requested",
  },
  signature_request: {
    singular: "signature request",
    plural: "signature requests",
  },
  answer_request: {
    singular: "information request",
    plural: "information requests",
  },
  PAYMENT_REQUESTED: {
    singular: "payment request",
    plural: "payment requests",
  },
  REVIEW_AND_PAY: {
    singular: "review & pay request",
    plural: "review & pay requests",
  },
  CART: { singular: "cart item", plural: "cart items" },
  STATE_REGISTRATIONS_DUE: {
    singular: "state registration",
    plural: "state registrations",
  },
  STATE_REGISTRATION_MISSING_INFO: {
    singular: "state registration detail",
    plural: "state registration details",
  },
  RA_EXPIRING: {
    singular: "registered agent renewal",
    plural: "registered agent renewals",
  },
};

const humanize = (customType: string): Noun => {
  const label = customType
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\s*type$/, "")
    .replace(/\s*custom$/, "")
    .trim();
  return { singular: label, plural: label };
};

export const buildBucketSubtitle = (items: DeadlineActionItem[]): string => {
  const totals = new Map<string, { noun: Noun; count: number }>();

  items.forEach((item) => {
    const noun =
      CUSTOM_TYPE_NOUN[item.custom_type] ?? humanize(item.custom_type);
    const existing = totals.get(noun.plural);
    const count = existing ? existing.count + item.count : item.count;

    totals.set(noun.plural, { noun, count });
  });

  return Array.from(totals.values())
    .map(({ noun, count }) => pluralize(count, noun.singular, noun.plural))
    .join(", ");
};
